module.exports = __webpack_public_path__ + "static/media/odontograma.24027cf3.jpeg";